export default function() {
  return [
  {
    "pedido": 1,
    "nro_asociado": "03843271/1",
    "apellido": "Medina",
    "nombre": "Dennis",
    "plan": "K030",
    "localidad": "Itajaí",
    "cp": "89691-645",
    "direccion": "Ap #437-1866 Sociis St.",
    "provincia": "Santa Catarina",
    "diagnostico": "Aenean euismod mauris eu elit. Nulla facilisi. Sed neque. Sed",
    "estado": "Pendiente",
    "prestador_solicitante": "Quam Curabitur Company",
    "prestador_actuante": "Ut Mi Incorporated",
    "prestador_actuante_codigo": "9214",
    "fecha_desde": "2018-04-24",
    "fecha_hasta": "2019-12-17",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "234",
    "descripcion": "elit. Nulla facilisi. Sed neque. Sed eget lacus. Mauris non dui nec urna",
    "practicas": [
      {
        "det": "713",
        "descripcion": "sed libero. Proin sed turpis nec mauris blandit mattis. Cras eget nisi dictum augue malesuada malesuada. Integer id magna",
        "fecha_desde": "2019-07-31",
        "fecha_hasta": "2020-01-18",
        "cantidad": 2,
        "frecuencia": "DIARIA"
      },
      {
        "det": "915",
        "descripcion": "neque sed dictum eleifend, nunc risus varius orci, in",
        "fecha_desde": "2019-08-01",
        "fecha_hasta": "2019-05-22",
        "cantidad": 8,
        "frecuencia": "DIARIA"
      },
      {
        "det": "087",
        "descripcion": "mi eleifend egestas. Sed pharetra, felis eget varius ultrices, mauris ipsum porta elit, a feugiat tellus lorem eu metus. In",
        "fecha_desde": "2020-07-02",
        "fecha_hasta": "2018-12-19",
        "cantidad": 7,
        "frecuencia": "SEMANAL"
      }
    ]
  },
  {
    "pedido": 2,
    "nro_asociado": "46415211/1",
    "apellido": "Sims",
    "nombre": "Carson",
    "plan": "Q093",
    "localidad": "Tiltil",
    "cp": "472614",
    "direccion": "Ap #173-263 Mauris. Avenue",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "Donec sollicitudin adipiscing ligula. Aenean gravida nunc sed pede. Cum",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Adipiscing Elit Inc.",
    "prestador_actuante": "Suspendisse Consulting",
    "prestador_actuante_codigo": "5742",
    "fecha_desde": "2018-06-22",
    "fecha_hasta": "2019-02-15",
    "cantidad": 2,
    "frecuencia": "SEMANAL",
    "det": "452",
    "descripcion": "ullamcorper. Duis",
    "practicas": [
      {
        "det": "036",
        "descripcion": "Donec dignissim magna a tortor. Nunc commodo auctor velit. Aliquam nisl. Nulla eu neque",
        "fecha_desde": "2019-03-24",
        "fecha_hasta": "2020-05-02",
        "cantidad": 6,
        "frecuencia": "SEMANAL"
      }
    ]
  },
  {
    "pedido": 3,
    "nro_asociado": "84836408/1",
    "apellido": "Anthony",
    "nombre": "Lester",
    "plan": "Q194",
    "localidad": "Reus",
    "cp": "91877",
    "direccion": "4590 Semper. Rd.",
    "provincia": "Catalunya",
    "diagnostico": "sit amet, consectetuer adipiscing elit. Etiam laoreet, libero et tristique",
    "estado": "Pendiente",
    "prestador_solicitante": "Aliquet Incorporated",
    "prestador_actuante": "In Associates",
    "prestador_actuante_codigo": "8201",
    "fecha_desde": "2019-02-22",
    "fecha_hasta": "2018-12-27",
    "cantidad": 3,
    "frecuencia": "DIARIA",
    "det": "590",
    "descripcion": "pellentesque massa lobortis ultrices. Vivamus rhoncus. Donec est. Nunc ullamcorper, velit in aliquet lobortis,",
    "practicas": [
      {
        "det": "191",
        "descripcion": "dui nec urna suscipit nonummy. Fusce",
        "fecha_desde": "2020-06-14",
        "fecha_hasta": "2018-08-21",
        "cantidad": 8,
        "frecuencia": "SEMANAL"
      },
      {
        "det": "043",
        "descripcion": "arcu iaculis enim, sit amet ornare lectus justo eu arcu. Morbi sit",
        "fecha_desde": "2020-03-20",
        "fecha_hasta": "2019-07-14",
        "cantidad": 5,
        "frecuencia": "DIARIA"
      }
    ]
  },
  {
    "pedido": 4,
    "nro_asociado": "43758525/1",
    "apellido": "Ruiz",
    "nombre": "Lacey",
    "plan": "N725",
    "localidad": "Murcia",
    "cp": "74299",
    "direccion": "Ap #763-9832 In Road",
    "provincia": "Murcia",
    "diagnostico": "ullamcorper magna. Sed eu eros. Nam consequat dolor vitae dolor.",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Eu Ltd",
    "prestador_actuante": "Mauris Blandit Mattis Ltd",
    "prestador_actuante_codigo": "1834",
    "fecha_desde": "2019-09-18",
    "fecha_hasta": "2018-11-17",
    "cantidad": 10,
    "frecuencia": "DIARIA",
    "det": "739",
    "descripcion": "nec enim. Nunc ut erat.",
    "practicas": [
      {
        "det": "428",
        "descripcion": "rutrum urna, nec luctus felis purus ac tellus. Suspendisse sed dolor. Fusce mi lorem, vehicula et,",
        "fecha_desde": "2019-02-22",
        "fecha_hasta": "2020-03-05",
        "cantidad": 8,
        "frecuencia": "SEMANAL"
      },
      {
        "det": "862",
        "descripcion": "mus. Donec dignissim magna a tortor. Nunc commodo auctor velit.",
        "fecha_desde": "2020-04-12",
        "fecha_hasta": "2019-09-02",
        "cantidad": 3,
        "frecuencia": "DIARIA"
      },
      {
        "det": "579",
        "descripcion": "pede ac urna. Ut tincidunt vehicula risus. Nulla eget metus eu erat semper rutrum. Fusce dolor quam,",
        "fecha_desde": "2018-11-28",
        "fecha_hasta": "2019-01-17",
        "cantidad": 1,
        "frecuencia": "DIARIA"
      }
    ]
  },
  {
    "pedido": 5,
    "nro_asociado": "28658691/1",
    "apellido": "Rios",
    "nombre": "Maggie",
    "plan": "R112",
    "localidad": "Luziânia",
    "cp": "75718-777",
    "direccion": "1804 Enim. Avenue",
    "provincia": "Goiás",
    "diagnostico": "elementum, lorem ut aliquam iaculis, lacus pede sagittis augue, eu",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Lorem LLP",
    "prestador_actuante": "Pede Incorporated",
    "prestador_actuante_codigo": "7846",
    "fecha_desde": "2019-06-27",
    "fecha_hasta": "2018-08-12",
    "cantidad": 7,
    "frecuencia": "DIARIA",
    "det": "569",
    "descripcion": "at fringilla purus mauris a nunc.",
    "practicas": []
  },
  {
    "pedido": 6,
    "nro_asociado": "34611669/1",
    "apellido": "Faulkner",
    "nombre": "Raja",
    "plan": "Q720",
    "localidad": "San José de Alajuela",
    "cp": "20614",
    "direccion": "236 Vivamus St.",
    "provincia": "Alajuela",
    "diagnostico": "semper erat, in consectetuer ipsum nunc id enim. Curabitur massa.",
    "estado": "Pendiente",
    "prestador_solicitante": "Tellus Institute",
    "prestador_actuante": "Dapibus Ligula Consulting",
    "prestador_actuante_codigo": "9248",
    "fecha_desde": "2018-09-14",
    "fecha_hasta": "2018-09-16",
    "cantidad": 5,
    "frecuencia": "SEMANAL",
    "det": "689",
    "descripcion": "euismod in, dolor. Fusce feugiat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aliquam auctor, velit",
    "practicas": []
  },
  {
    "pedido": 7,
    "nro_asociado": "30944128/1",
    "apellido": "Webb",
    "nombre": "Travis",
    "plan": "A384",
    "localidad": "Abaetetuba",
    "cp": "67166-055",
    "direccion": "237-2585 Mattis. Av.",
    "provincia": "Pará",
    "diagnostico": "ornare, lectus ante dictum mi, ac mattis velit justo nec",
    "estado": "Asignada",
    "prestador_solicitante": "Purus Gravida Sagittis Institute",
    "prestador_actuante": "Donec Institute",
    "prestador_actuante_codigo": "5469",
    "fecha_desde": "2018-09-20",
    "fecha_hasta": "2020-08-15",
    "cantidad": 5,
    "frecuencia": "SEMANAL",
    "det": "584",
    "descripcion": "adipiscing fringilla, porttitor vulputate, posuere vulputate, lacus. Cras interdum. Nunc sollicitudin commodo ipsum. Suspendisse non leo. Vivamus nibh dolor, nonummy",
    "practicas": []
  },
  {
    "pedido": 8,
    "nro_asociado": "85735431/1",
    "apellido": "King",
    "nombre": "Gwendolyn",
    "plan": "T061",
    "localidad": "Quesada",
    "cp": "21216",
    "direccion": "3037 Sapien Avenue",
    "provincia": "Alajuela",
    "diagnostico": "tristique neque venenatis lacus. Etiam bibendum fermentum metus. Aenean sed",
    "estado": "Pendiente",
    "prestador_solicitante": "Metus Eu Erat LLC",
    "prestador_actuante": "Ac Mattis Incorporated",
    "prestador_actuante_codigo": "4531",
    "fecha_desde": "2019-05-14",
    "fecha_hasta": "2018-10-29",
    "cantidad": 4,
    "frecuencia": "SEMANAL",
    "det": "858",
    "descripcion": "arcu et pede. Nunc sed orci lobortis augue scelerisque mollis. Phasellus libero mauris, aliquam eu, accumsan",
    "practicas": []
  },
  {
    "pedido": 9,
    "nro_asociado": "95934508/1",
    "apellido": "Banks",
    "nombre": "Tallulah",
    "plan": "R995",
    "localidad": "San Rafael",
    "cp": "21315",
    "direccion": "Ap #656-8469 Lobortis Road",
    "provincia": "Alajuela",
    "diagnostico": "neque. Morbi quis urna. Nunc quis arcu vel quam dignissim",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Duis At Lacus Industries",
    "prestador_actuante": "Pharetra Ut Pharetra Company",
    "prestador_actuante_codigo": "4628",
    "fecha_desde": "2018-05-09",
    "fecha_hasta": "2019-04-24",
    "cantidad": 9,
    "frecuencia": "DIARIA",
    "det": "430",
    "descripcion": "Mauris nulla. Integer urna. Vivamus molestie dapibus",
    "practicas": []
  },
  {
    "pedido": 10,
    "nro_asociado": "48151897/1",
    "apellido": "Ferguson",
    "nombre": "Leilani",
    "plan": "L159",
    "localidad": "Bilbo",
    "cp": "22775",
    "direccion": "P.O. Box 620, 2213 Nec St.",
    "provincia": "Euskadi",
    "diagnostico": "ornare placerat, orci lacus vestibulum lorem, sit amet ultricies sem",
    "estado": "Pendiente",
    "prestador_solicitante": "Pede Blandit Corp.",
    "prestador_actuante": "Neque Nullam Ut Industries",
    "prestador_actuante_codigo": "7242",
    "fecha_desde": "2018-08-14",
    "fecha_hasta": "2020-02-10",
    "cantidad": 4,
    "frecuencia": "SEMANAL",
    "det": "658",
    "descripcion": "massa rutrum magna. Cras convallis convallis dolor. Quisque tincidunt pede ac urna. Ut tincidunt vehicula risus. Nulla eget metus",
    "practicas": []
  },
  {
    "pedido": 11,
    "nro_asociado": "39530173/1",
    "apellido": "Walls",
    "nombre": "Byron",
    "plan": "I788",
    "localidad": "Marbella",
    "cp": "29054",
    "direccion": "P.O. Box 201, 656 Metus. Avenue",
    "provincia": "Andalucía",
    "diagnostico": "Sed nec metus facilisis lorem tristique aliquet. Phasellus fermentum convallis",
    "estado": "Asignada",
    "prestador_solicitante": "Ipsum Limited",
    "prestador_actuante": "Et Corp.",
    "prestador_actuante_codigo": "3984",
    "fecha_desde": "2018-05-23",
    "fecha_hasta": "2019-08-11",
    "cantidad": 5,
    "frecuencia": "DIARIA",
    "det": "164",
    "descripcion": "suscipit nonummy. Fusce fermentum",
    "practicas": []
  },
  {
    "pedido": 12,
    "nro_asociado": "70499505/1",
    "apellido": "Lara",
    "nombre": "Ginger",
    "plan": "I585",
    "localidad": "Cabrero",
    "cp": "034319",
    "direccion": "Ap #292-9415 Rutrum Rd.",
    "provincia": "Biobío",
    "diagnostico": "ultricies ornare, elit elit fermentum risus, at fringilla purus mauris",
    "estado": "Asignada",
    "prestador_solicitante": "Sagittis Duis Gravida Company",
    "prestador_actuante": "Nec Limited",
    "prestador_actuante_codigo": "8329",
    "fecha_desde": "2018-03-08",
    "fecha_hasta": "2019-01-09",
    "cantidad": 3,
    "frecuencia": "SEMANAL",
    "det": "510",
    "descripcion": "libero. Morbi accumsan laoreet ipsum. Curabitur consequat, lectus sit amet",
    "practicas": []
  },
  {
    "pedido": 13,
    "nro_asociado": "20608609/1",
    "apellido": "Roth",
    "nombre": "Ralph",
    "plan": "J627",
    "localidad": "Los Andes",
    "cp": "357664",
    "direccion": "4107 Nam Rd.",
    "provincia": "Valparaíso",
    "diagnostico": "enim. Suspendisse aliquet, sem ut cursus luctus, ipsum leo elementum",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Non Consulting",
    "prestador_actuante": "Ullamcorper Ltd",
    "prestador_actuante_codigo": "8652",
    "fecha_desde": "2018-11-12",
    "fecha_hasta": "2018-08-22",
    "cantidad": 1,
    "frecuencia": "SEMANAL",
    "det": "572",
    "descripcion": "ultrices a, auctor non, feugiat nec, diam. Duis mi enim, condimentum eget, volutpat ornare, facilisis eget, ipsum.",
    "practicas": []
  },
  {
    "pedido": 14,
    "nro_asociado": "46134778/1",
    "apellido": "Boyer",
    "nombre": "Gwendolyn",
    "plan": "R004",
    "localidad": "Lo Prado",
    "cp": "566657",
    "direccion": "Ap #903-8474 Mollis. Ave",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "Quisque imperdiet, erat nonummy ultricies ornare, elit elit fermentum risus,",
    "estado": "Pendiente",
    "prestador_solicitante": "Lorem Ut Company",
    "prestador_actuante": "Accumsan Industries",
    "prestador_actuante_codigo": "8573",
    "fecha_desde": "2019-07-04",
    "fecha_hasta": "2019-09-16",
    "cantidad": 3,
    "frecuencia": "DIARIA",
    "det": "465",
    "descripcion": "ligula elit,",
    "practicas": []
  },
  {
    "pedido": 15,
    "nro_asociado": "01034882/1",
    "apellido": "Moran",
    "nombre": "Harlan",
    "plan": "A964",
    "localidad": "Peñalolén",
    "cp": "006109",
    "direccion": "6819 Tellus Rd.",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "quam. Curabitur vel lectus. Cum sociis natoque penatibus et magnis",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Etiam Bibendum Ltd",
    "prestador_actuante": "Ut Sagittis Lobortis Incorporated",
    "prestador_actuante_codigo": "8563",
    "fecha_desde": "2019-05-19",
    "fecha_hasta": "2020-02-05",
    "cantidad": 6,
    "frecuencia": "DIARIA",
    "det": "042",
    "descripcion": "ut, pellentesque eget, dictum placerat, augue. Sed molestie. Sed id risus quis diam",
    "practicas": []
  },
  {
    "pedido": 16,
    "nro_asociado": "61317073/1",
    "apellido": "Reese",
    "nombre": "Quincy",
    "plan": "L128",
    "localidad": "Leganés",
    "cp": "02431",
    "direccion": "671-6432 Id, Road",
    "provincia": "Madrid",
    "diagnostico": "sit amet, dapibus id, blandit at, nisi. Cum sociis natoque",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Consectetuer Adipiscing Elit Foundation",
    "prestador_actuante": "Aliquam Enim Nec Associates",
    "prestador_actuante_codigo": "0837",
    "fecha_desde": "2019-09-03",
    "fecha_hasta": "2019-01-04",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "038",
    "descripcion": "erat. Sed nunc est, mollis non, cursus non, egestas a, dui. Cras",
    "practicas": []
  },
  {
    "pedido": 17,
    "nro_asociado": "30337706/1",
    "apellido": "Vega",
    "nombre": "Salvador",
    "plan": "T097",
    "localidad": "San José de Alajuela",
    "cp": "21109",
    "direccion": "309-1592 Faucibus Rd.",
    "provincia": "Alajuela",
    "diagnostico": "Phasellus dapibus quam quis diam. Pellentesque habitant morbi tristique senectus",
    "estado": "Pendiente",
    "prestador_solicitante": "Nec LLP",
    "prestador_actuante": "Ornare Limited",
    "prestador_actuante_codigo": "4973",
    "fecha_desde": "2019-03-29",
    "fecha_hasta": "2018-10-01",
    "cantidad": 5,
    "frecuencia": "SEMANAL",
    "det": "106",
    "descripcion": "dui nec urna suscipit nonummy. Fusce fermentum fermentum arcu. Vestibulum ante ipsum primis in faucibus orci",
    "practicas": []
  },
  {
    "pedido": 18,
    "nro_asociado": "54582544/1",
    "apellido": "Sanders",
    "nombre": "Leo",
    "plan": "K976",
    "localidad": "Huesca",
    "cp": "45363",
    "direccion": "6402 Ante Rd.",
    "provincia": "Aragón",
    "diagnostico": "pharetra. Nam ac nulla. In tincidunt congue turpis. In condimentum.",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Dolor Sit Incorporated",
    "prestador_actuante": "Sociis Natoque Institute",
    "prestador_actuante_codigo": "3264",
    "fecha_desde": "2018-12-22",
    "fecha_hasta": "2020-01-05",
    "cantidad": 7,
    "frecuencia": "DIARIA",
    "det": "229",
    "descripcion": "risus, at fringilla purus mauris a nunc. In at pede. Cras vulputate velit eu sem.",
    "practicas": []
  },
  {
    "pedido": 19,
    "nro_asociado": "63312153/1",
    "apellido": "Britt",
    "nombre": "Cooper",
    "plan": "A053",
    "localidad": "Maipú",
    "cp": "008473",
    "direccion": "P.O. Box 303, 2166 Blandit Avenue",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "semper tellus id nunc interdum feugiat. Sed nec metus facilisis",
    "estado": "Pendiente",
    "prestador_solicitante": "Eget Laoreet Posuere LLP",
    "prestador_actuante": "Augue Institute",
    "prestador_actuante_codigo": "0790",
    "fecha_desde": "2018-07-08",
    "fecha_hasta": "2019-02-28",
    "cantidad": 6,
    "frecuencia": "DIARIA",
    "det": "506",
    "descripcion": "magna.",
    "practicas": []
  },
  {
    "pedido": 20,
    "nro_asociado": "35510950/1",
    "apellido": "Greer",
    "nombre": "Molly",
    "plan": "I465",
    "localidad": "Barranca",
    "cp": "30808",
    "direccion": "472-7392 Tortor, Road",
    "provincia": "Puntarenas",
    "diagnostico": "eu, placerat eget, venenatis a, magna. Lorem ipsum dolor sit",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Condimentum Donec Institute",
    "prestador_actuante": "In Aliquet Institute",
    "prestador_actuante_codigo": "8038",
    "fecha_desde": "2019-07-23",
    "fecha_hasta": "2019-05-03",
    "cantidad": 9,
    "frecuencia": "DIARIA",
    "det": "072",
    "descripcion": "pede. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Proin vel",
    "practicas": []
  },
  {
    "pedido": 21,
    "nro_asociado": "74531203/1",
    "apellido": "Oconnor",
    "nombre": "Kyra",
    "plan": "F104",
    "localidad": "Uberlândia",
    "cp": "35379284",
    "direccion": "4190 Nunc, Rd.",
    "provincia": "Minas Gerais",
    "diagnostico": "justo nec ante. Maecenas mi felis, adipiscing fringilla, porttitor vulputate,",
    "estado": "Asignada",
    "prestador_solicitante": "In Felis PC",
    "prestador_actuante": "Mollis Non Institute",
    "prestador_actuante_codigo": "5546",
    "fecha_desde": "2018-11-04",
    "fecha_hasta": "2020-06-25",
    "cantidad": 3,
    "frecuencia": "SEMANAL",
    "det": "054",
    "descripcion": "cursus luctus, ipsum leo elementum sem, vitae",
    "practicas": []
  },
  {
    "pedido": 22,
    "nro_asociado": "20031517/1",
    "apellido": "Diaz",
    "nombre": "Quemby",
    "plan": "C652",
    "localidad": "Sevilla",
    "cp": "03142",
    "direccion": "168-5074 Neque St.",
    "provincia": "Andalucía",
    "diagnostico": "et arcu imperdiet ullamcorper. Duis at lacus. Quisque purus sapien,",
    "estado": "Pendiente",
    "prestador_solicitante": "Tellus Sem Industries",
    "prestador_actuante": "At PC",
    "prestador_actuante_codigo": "4359",
    "fecha_desde": "2019-07-04",
    "fecha_hasta": "2019-01-16",
    "cantidad": 5,
    "frecuencia": "SEMANAL",
    "det": "240",
    "descripcion": "penatibus et magnis dis",
    "practicas": []
  },
  {
    "pedido": 23,
    "nro_asociado": "17465061/1",
    "apellido": "Gay",
    "nombre": "Brenden",
    "plan": "H813",
    "localidad": "San Vicente",
    "cp": "12113",
    "direccion": "2890 Eget Ave",
    "provincia": "San José",
    "diagnostico": "ante bibendum ullamcorper. Duis cursus, diam at pretium aliquet, metus",
    "estado": "Pendiente",
    "prestador_solicitante": "Ac Tellus Suspendisse Corporation",
    "prestador_actuante": "Tincidunt Nunc Ac Ltd",
    "prestador_actuante_codigo": "4262",
    "fecha_desde": "2019-01-16",
    "fecha_hasta": "2019-11-06",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "739",
    "descripcion": "in, dolor. Fusce feugiat.",
    "practicas": []
  },
  {
    "pedido": 24,
    "nro_asociado": "63443747/1",
    "apellido": "Cabrera",
    "nombre": "Patience",
    "plan": "V443",
    "localidad": "Turrialba",
    "cp": "30215",
    "direccion": "5751 Quis Avenue",
    "provincia": "Cartago",
    "diagnostico": "parturient montes, nascetur ridiculus mus. Proin vel nisl. Quisque fringilla",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Egestas Foundation",
    "prestador_actuante": "Nec Euismod Company",
    "prestador_actuante_codigo": "1081",
    "fecha_desde": "2019-03-14",
    "fecha_hasta": "2020-06-13",
    "cantidad": 4,
    "frecuencia": "DIARIA",
    "det": "058",
    "descripcion": "nec, diam. Duis mi enim, condimentum eget, volutpat ornare, facilisis eget, ipsum. Donec sollicitudin",
    "practicas": []
  },
  {
    "pedido": 25,
    "nro_asociado": "87937138/1",
    "apellido": "Ramsey",
    "nombre": "Solomon",
    "plan": "K014",
    "localidad": "Mogi das Cruzes",
    "cp": "11173-151",
    "direccion": "8029 Tellus. Rd.",
    "provincia": "São Paulo",
    "diagnostico": "accumsan neque et nunc. Quisque ornare tortor at risus. Nunc",
    "estado": "Pendiente",
    "prestador_solicitante": "Vitae Limited",
    "prestador_actuante": "Velit Cras Industries",
    "prestador_actuante_codigo": "1113",
    "fecha_desde": "2018-05-29",
    "fecha_hasta": "2020-06-17",
    "cantidad": 3,
    "frecuencia": "SEMANAL",
    "det": "442",
    "descripcion": "nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique neque venenatis lacus. Etiam bibendum fermentum metus. Aenean",
    "practicas": []
  },
  {
    "pedido": 26,
    "nro_asociado": "22536535/1",
    "apellido": "Rutledge",
    "nombre": "Bree",
    "plan": "F181",
    "localidad": "Ulloa (Barrial)",
    "cp": "40907",
    "direccion": "921-1567 Fermentum St.",
    "provincia": "Heredia",
    "diagnostico": "et, commodo at, libero. Morbi accumsan laoreet ipsum. Curabitur consequat,",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Nisl Sem Consequat PC",
    "prestador_actuante": "Euismod Ac Fermentum Foundation",
    "prestador_actuante_codigo": "5553",
    "fecha_desde": "2018-04-01",
    "fecha_hasta": "2018-12-04",
    "cantidad": 1,
    "frecuencia": "DIARIA",
    "det": "214",
    "descripcion": "Aliquam erat volutpat. Nulla",
    "practicas": []
  },
  {
    "pedido": 27,
    "nro_asociado": "56456006/1",
    "apellido": "Barker",
    "nombre": "Robert",
    "plan": "A800",
    "localidad": "Santa Maria",
    "cp": "91494-054",
    "direccion": "Ap #780-4884 Sodales Rd.",
    "provincia": "Rio Grande do Sul",
    "diagnostico": "libero est, congue a, aliquet vel, vulputate eu, odio. Phasellus",
    "estado": "Asignada",
    "prestador_solicitante": "Sagittis Augue Eu Limited",
    "prestador_actuante": "Dis Ltd",
    "prestador_actuante_codigo": "5104",
    "fecha_desde": "2018-04-22",
    "fecha_hasta": "2020-06-29",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "587",
    "descripcion": "Morbi metus. Vivamus euismod urna. Nullam lobortis",
    "practicas": []
  },
  {
    "pedido": 28,
    "nro_asociado": "65733994/1",
    "apellido": "Pittman",
    "nombre": "Clarke",
    "plan": "V094",
    "localidad": "Feira de Santana",
    "cp": "42306-924",
    "direccion": "P.O. Box 741, 702 Consectetuer Road",
    "provincia": "Bahia",
    "diagnostico": "egestas. Fusce aliquet magna a neque. Nullam ut nisi a",
    "estado": "Asignada",
    "prestador_solicitante": "Euismod Ac LLC",
    "prestador_actuante": "Non Vestibulum Institute",
    "prestador_actuante_codigo": "8023",
    "fecha_desde": "2019-01-25",
    "fecha_hasta": "2018-11-03",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "350",
    "descripcion": "felis eget varius ultrices,",
    "practicas": []
  },
  {
    "pedido": 29,
    "nro_asociado": "25251239/1",
    "apellido": "Mcleod",
    "nombre": "Paloma",
    "plan": "P200",
    "localidad": "Piracicaba",
    "cp": "11912-135",
    "direccion": "222-8288 Accumsan Road",
    "provincia": "São Paulo",
    "diagnostico": "odio semper cursus. Integer mollis. Integer tincidunt aliquam arcu. Aliquam",
    "estado": "Asignada",
    "prestador_solicitante": "Non Enim Mauris Associates",
    "prestador_actuante": "Elementum Purus LLP",
    "prestador_actuante_codigo": "2655",
    "fecha_desde": "2018-10-18",
    "fecha_hasta": "2019-02-22",
    "cantidad": 5,
    "frecuencia": "DIARIA",
    "det": "633",
    "descripcion": "ornare lectus justo eu arcu.",
    "practicas": []
  },
  {
    "pedido": 30,
    "nro_asociado": "89930374/1",
    "apellido": "Wells",
    "nombre": "MacKensie",
    "plan": "F825",
    "localidad": "Murcia",
    "cp": "23019",
    "direccion": "9436 Adipiscing Street",
    "provincia": "Murcia",
    "diagnostico": "lorem, eget mollis lectus pede et risus. Quisque libero lacus,",
    "estado": "Pendiente",
    "prestador_solicitante": "Tortor Associates",
    "prestador_actuante": "Sed Sem Egestas Associates",
    "prestador_actuante_codigo": "4682",
    "fecha_desde": "2019-02-17",
    "fecha_hasta": "2019-03-25",
    "cantidad": 8,
    "frecuencia": "DIARIA",
    "det": "243",
    "descripcion": "ut odio vel est tempor bibendum. Donec felis orci, adipiscing non, luctus sit amet, faucibus",
    "practicas": []
  },
  {
    "pedido": 31,
    "nro_asociado": "31615886/1",
    "apellido": "Burt",
    "nombre": "Benjamin",
    "plan": "B446",
    "localidad": "Los Sauces",
    "cp": "626494",
    "direccion": "232-2875 Mollis. Street",
    "provincia": "Araucanía",
    "diagnostico": "Etiam bibendum fermentum metus. Aenean sed pede nec ante blandit",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Risus Nulla Consulting",
    "prestador_actuante": "Cum Sociis Foundation",
    "prestador_actuante_codigo": "1138",
    "fecha_desde": "2019-07-14",
    "fecha_hasta": "2019-01-10",
    "cantidad": 2,
    "frecuencia": "DIARIA",
    "det": "462",
    "descripcion": "amet, consectetuer adipiscing elit. Aliquam auctor, velit",
    "practicas": []
  },
  {
    "pedido": 32,
    "nro_asociado": "60472768/1",
    "apellido": "Figueroa",
    "nombre": "Jordan",
    "plan": "U860",
    "localidad": "San José de Alajuela",
    "cp": "20312",
    "direccion": "P.O. Box 855, 3385 Ipsum Rd.",
    "provincia": "Alajuela",
    "diagnostico": "dictum cursus. Nunc mauris elit, dictum eu, eleifend nec, malesuada",
    "estado": "Pendiente",
    "prestador_solicitante": "Convallis LLC",
    "prestador_actuante": "Proin Non Massa Limited",
    "prestador_actuante_codigo": "1313",
    "fecha_desde": "2018-12-02",
    "fecha_hasta": "2019-01-20",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "419",
    "descripcion": "Suspendisse aliquet molestie tellus. Aenean egestas hendrerit neque. In ornare sagittis felis. Donec tempor, est ac mattis",
    "practicas": []
  },
  {
    "pedido": 33,
    "nro_asociado": "46609767/1",
    "apellido": "Cleveland",
    "nombre": "Cameran",
    "plan": "D090",
    "localidad": "San Pablo",
    "cp": "41010",
    "direccion": "269-1734 Bibendum Ave",
    "provincia": "Heredia",
    "diagnostico": "ligula. Aenean euismod mauris eu elit. Nulla facilisi. Sed neque.",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Risus Odio Auctor Institute",
    "prestador_actuante": "Quisque Libero Associates",
    "prestador_actuante_codigo": "4219",
    "fecha_desde": "2019-08-15",
    "fecha_hasta": "2019-02-27",
    "cantidad": 4,
    "frecuencia": "SEMANAL",
    "det": "883",
    "descripcion": "consequat nec, mollis",
    "practicas": []
  },
  {
    "pedido": 34,
    "nro_asociado": "17161136/1",
    "apellido": "Macdonald",
    "nombre": "Cassidy",
    "plan": "R255",
    "localidad": "Salamanca",
    "cp": "85533",
    "direccion": "P.O. Box 367, 3177 Adipiscing Street",
    "provincia": "Castilla y León",
    "diagnostico": "id risus quis diam luctus lobortis. Class aptent taciti sociosqu",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Eget Massa Suspendisse Consulting",
    "prestador_actuante": "Ligula LLP",
    "prestador_actuante_codigo": "5706",
    "fecha_desde": "2019-08-02",
    "fecha_hasta": "2019-11-22",
    "cantidad": 8,
    "frecuencia": "DIARIA",
    "det": "601",
    "descripcion": "dolor vitae dolor. Donec fringilla. Donec feugiat metus sit amet ante. Vivamus non lorem vitae",
    "practicas": []
  },
  {
    "pedido": 35,
    "nro_asociado": "14713773/1",
    "apellido": "Mcclain",
    "nombre": "Guinevere",
    "plan": "W750",
    "localidad": "Tiltil",
    "cp": "122682",
    "direccion": "293-8971 Rutrum Rd.",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "convallis dolor. Quisque tincidunt pede ac urna. Ut tincidunt vehicula",
    "estado": "Pendiente",
    "prestador_solicitante": "Vulputate Nisi Sem Limited",
    "prestador_actuante": "Lectus Convallis Est Inc.",
    "prestador_actuante_codigo": "8037",
    "fecha_desde": "2018-03-08",
    "fecha_hasta": "2019-07-24",
    "cantidad": 8,
    "frecuencia": "DIARIA",
    "det": "997",
    "descripcion": "purus ac tellus. Suspendisse sed dolor. Fusce mi lorem, vehicula et, rutrum eu, ultrices sit amet, risus.",
    "practicas": []
  },
  {
    "pedido": 36,
    "nro_asociado": "61915492/1",
    "apellido": "Burton",
    "nombre": "Fredericka",
    "plan": "C956",
    "localidad": "Gravilias",
    "cp": "10319",
    "direccion": "Ap #411-9502 Sodales St.",
    "provincia": "San José",
    "diagnostico": "odio tristique pharetra. Quisque ac libero nec ligula consectetuer rhoncus.",
    "estado": "Asignada",
    "prestador_solicitante": "Mi Corp.",
    "prestador_actuante": "A Sollicitudin Incorporated",
    "prestador_actuante_codigo": "9266",
    "fecha_desde": "2019-06-01",
    "fecha_hasta": "2019-02-17",
    "cantidad": 1,
    "frecuencia": "SEMANAL",
    "det": "366",
    "descripcion": "porttitor vulputate, posuere vulputate, lacus. Cras interdum. Nunc sollicitudin",
    "practicas": []
  },
  {
    "pedido": 37,
    "nro_asociado": "11207955/1",
    "apellido": "Colon",
    "nombre": "Dennis",
    "plan": "I869",
    "localidad": "Parauapebas",
    "cp": "68056-919",
    "direccion": "4243 Nunc St.",
    "provincia": "Pará",
    "diagnostico": "facilisis, magna tellus faucibus leo, in lobortis tellus justo sit",
    "estado": "Pendiente",
    "prestador_solicitante": "Quam Quis Company",
    "prestador_actuante": "Mauris Vel Industries",
    "prestador_actuante_codigo": "0594",
    "fecha_desde": "2018-12-10",
    "fecha_hasta": "2019-12-21",
    "cantidad": 6,
    "frecuencia": "SEMANAL",
    "det": "777",
    "descripcion": "tristique aliquet. Phasellus fermentum convallis ligula. Donec luctus aliquet odio.",
    "practicas": []
  },
  {
    "pedido": 38,
    "nro_asociado": "23103408/1",
    "apellido": "Maxwell",
    "nombre": "Isaac",
    "plan": "H684",
    "localidad": "San Rafael Abajo",
    "cp": "12108",
    "direccion": "P.O. Box 658, 7919 Est, Rd.",
    "provincia": "San José",
    "diagnostico": "pede et risus. Quisque libero lacus, varius et, euismod et,",
    "estado": "Pendiente",
    "prestador_solicitante": "Aenean LLP",
    "prestador_actuante": "Congue LLP",
    "prestador_actuante_codigo": "8059",
    "fecha_desde": "2019-01-02",
    "fecha_hasta": "2018-08-11",
    "cantidad": 3,
    "frecuencia": "DIARIA",
    "det": "728",
    "descripcion": "nunc ac mattis ornare, lectus ante dictum mi, ac mattis velit justo nec ante. Maecenas mi felis, adipiscing fringilla, porttitor",
    "practicas": []
  },
  {
    "pedido": 39,
    "nro_asociado": "44234774/1",
    "apellido": "Massey",
    "nombre": "Aretha",
    "plan": "A970",
    "localidad": "Carapicuíba",
    "cp": "17942-443",
    "direccion": "6750 Sem. Avenue",
    "provincia": "São Paulo",
    "diagnostico": "mauris sapien, cursus in, hendrerit consectetuer, cursus et, magna. Praesent",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Donec Porttitor Tellus Ltd",
    "prestador_actuante": "Cras Vulputate Velit Corporation",
    "prestador_actuante_codigo": "2031",
    "fecha_desde": "2019-04-01",
    "fecha_hasta": "2019-01-04",
    "cantidad": 10,
    "frecuencia": "DIARIA",
    "det": "907",
    "descripcion": "feugiat. Sed nec metus facilisis",
    "practicas": []
  },
  {
    "pedido": 40,
    "nro_asociado": "80039593/1",
    "apellido": "Frost",
    "nombre": "Cairo",
    "plan": "K721",
    "localidad": "Turrialba",
    "cp": "30205",
    "direccion": "3348 Turpis. St.",
    "provincia": "Cartago",
    "diagnostico": "a, aliquet vel, vulputate eu, odio. Phasellus at augue id",
    "estado": "Asignada",
    "prestador_solicitante": "Consectetuer LLP",
    "prestador_actuante": "Senectus Et Netus Corporation",
    "prestador_actuante_codigo": "6674",
    "fecha_desde": "2019-04-06",
    "fecha_hasta": "2019-01-18",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "316",
    "descripcion": "Nulla facilisi. Sed neque. Sed eget lacus. Mauris non dui nec urna suscipit nonummy. Fusce fermentum fermentum arcu. Vestibulum",
    "practicas": []
  },
  {
    "pedido": 41,
    "nro_asociado": "50053273/1",
    "apellido": "Munoz",
    "nombre": "Burke",
    "plan": "D178",
    "localidad": "L'Hospitalet de Llobregat",
    "cp": "51313",
    "direccion": "758-1211 Sed St.",
    "provincia": "Catalunya",
    "diagnostico": "et, rutrum eu, ultrices sit amet, risus. Donec nibh enim,",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Tortor Nunc LLP",
    "prestador_actuante": "Aliquet Molestie Tellus Limited",
    "prestador_actuante_codigo": "1627",
    "fecha_desde": "2018-12-16",
    "fecha_hasta": "2019-06-24",
    "cantidad": 9,
    "frecuencia": "DIARIA",
    "det": "313",
    "descripcion": "id enim. Curabitur massa. Vestibulum accumsan neque et nunc. Quisque ornare tortor at risus. Nunc ac sem ut",
    "practicas": []
  },
  {
    "pedido": 42,
    "nro_asociado": "44394298/1",
    "apellido": "Randall",
    "nombre": "Wynne",
    "plan": "K281",
    "localidad": "Salamanca",
    "cp": "34831",
    "direccion": "195-4032 Aliquam Avenue",
    "provincia": "Castilla y León",
    "diagnostico": "eget, ipsum. Donec sollicitudin adipiscing ligula. Aenean gravida nunc sed",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Ipsum Primis Ltd",
    "prestador_actuante": "Erat Volutpat Nulla LLP",
    "prestador_actuante_codigo": "5967",
    "fecha_desde": "2019-02-16",
    "fecha_hasta": "2020-03-11",
    "cantidad": 10,
    "frecuencia": "DIARIA",
    "det": "878",
    "descripcion": "Mauris vestibulum, neque sed dictum eleifend, nunc risus varius orci, in consequat enim diam vel arcu. Curabitur ut odio",
    "practicas": []
  },
  {
    "pedido": 43,
    "nro_asociado": "33978638/1",
    "apellido": "Rivers",
    "nombre": "Montana",
    "plan": "G647",
    "localidad": "Santiago",
    "cp": "173148",
    "direccion": "P.O. Box 621, 2731 Eget Road",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "Quisque nonummy ipsum non arcu. Vivamus sit amet risus. Donec",
    "estado": "Pendiente",
    "prestador_solicitante": "Nam Porttitor Scelerisque Limited",
    "prestador_actuante": "Faucibus Leo In LLC",
    "prestador_actuante_codigo": "1346",
    "fecha_desde": "2018-03-04",
    "fecha_hasta": "2019-05-31",
    "cantidad": 2,
    "frecuencia": "DIARIA",
    "det": "964",
    "descripcion": "Integer tincidunt aliquam arcu. Aliquam ultrices iaculis odio. Nam interdum enim",
    "practicas": []
  },
  {
    "pedido": 44,
    "nro_asociado": "64610871/1",
    "apellido": "Pratt",
    "nombre": "Benjamin",
    "plan": "Q869",
    "localidad": "Ipís",
    "cp": "12408",
    "direccion": "1301 Mi St.",
    "provincia": "San José",
    "diagnostico": "montes, nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique neque",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Vivamus Sit Consulting",
    "prestador_actuante": "Lacus PC",
    "prestador_actuante_codigo": "4776",
    "fecha_desde": "2019-01-21",
    "fecha_hasta": "2019-09-23",
    "cantidad": 1,
    "frecuencia": "DIARIA",
    "det": "086",
    "descripcion": "sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique neque venenatis",
    "practicas": []
  },
  {
    "pedido": 45,
    "nro_asociado": "15154687/1",
    "apellido": "Cooper",
    "nombre": "Ashton",
    "plan": "B563",
    "localidad": "Alajuela",
    "cp": "20302",
    "direccion": "Ap #182-9916 Erat Road",
    "provincia": "Alajuela",
    "diagnostico": "commodo at, libero. Morbi accumsan laoreet ipsum. Curabitur consequat, lectus",
    "estado": "Pendiente",
    "prestador_solicitante": "Parturient Montes Nascetur Institute",
    "prestador_actuante": "Nulla Ante Iaculis Foundation",
    "prestador_actuante_codigo": "7750",
    "fecha_desde": "2018-05-25",
    "fecha_hasta": "2020-08-12",
    "cantidad": 5,
    "frecuencia": "DIARIA",
    "det": "981",
    "descripcion": "est mauris, rhoncus id, mollis nec, cursus a, enim. Suspendisse aliquet, sem ut cursus luctus, ipsum leo elementum sem, vitae",
    "practicas": []
  },
  {
    "pedido": 46,
    "nro_asociado": "65793504/1",
    "apellido": "Fry",
    "nombre": "Kelsie",
    "plan": "Y927",
    "localidad": "São Luís",
    "cp": "65814-757",
    "direccion": "Ap #692-6592 Mauris Street",
    "provincia": "Maranhão",
    "diagnostico": "amet nulla. Donec non justo. Proin non massa non ante",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Congue A Aliquet Foundation",
    "prestador_actuante": "In At Foundation",
    "prestador_actuante_codigo": "2279",
    "fecha_desde": "2018-08-08",
    "fecha_hasta": "2019-12-22",
    "cantidad": 7,
    "frecuencia": "DIARIA",
    "det": "581",
    "descripcion": "non, hendrerit id, ante. Nunc mauris sapien, cursus in, hendrerit consectetuer, cursus et, magna. Praesent interdum ligula eu",
    "practicas": []
  },
  {
    "pedido": 47,
    "nro_asociado": "46762093/1",
    "apellido": "Marquez",
    "nombre": "Fritz",
    "plan": "G335",
    "localidad": "Campinas",
    "cp": "19364-794",
    "direccion": "P.O. Box 634, 4010 Bibendum St.",
    "provincia": "São Paulo",
    "diagnostico": "fermentum vel, mauris. Integer sem elit, pharetra ut, pharetra sed,",
    "estado": "Pendiente",
    "prestador_solicitante": "Metus Aenean Limited",
    "prestador_actuante": "Sodales Mauris Blandit Associates",
    "prestador_actuante_codigo": "2081",
    "fecha_desde": "2018-08-06",
    "fecha_hasta": "2020-02-24",
    "cantidad": 10,
    "frecuencia": "DIARIA",
    "det": "159",
    "descripcion": "commodo hendrerit. Donec porttitor tellus non magna. Nam ligula elit, pretium et, rutrum non, hendrerit id, ante. Nunc mauris sapien,",
    "practicas": []
  },
  {
    "pedido": 48,
    "nro_asociado": "31736881/1",
    "apellido": "Mcleod",
    "nombre": "Ray",
    "plan": "F198",
    "localidad": "San José de Alajuela",
    "cp": "21407",
    "direccion": "Ap #526-5965 Laoreet Road",
    "provincia": "Alajuela",
    "diagnostico": "eu tempor erat neque non quam. Pellentesque habitant morbi tristique",
    "estado": "Asignada",
    "prestador_solicitante": "Non Lobortis Ltd",
    "prestador_actuante": "Quam Curabitur Company",
    "prestador_actuante_codigo": "4817",
    "fecha_desde": "2018-03-01",
    "fecha_hasta": "2019-04-23",
    "cantidad": 8,
    "frecuencia": "DIARIA",
    "det": "516",
    "descripcion": "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique neque venenatis lacus.",
    "practicas": []
  },
  {
    "pedido": 49,
    "nro_asociado": "70102301/1",
    "apellido": "Yates",
    "nombre": "Gisela",
    "plan": "V889",
    "localidad": "San Francisco",
    "cp": "41108",
    "direccion": "P.O. Box 797, 4481 At, Av.",
    "provincia": "Heredia",
    "diagnostico": "dolor. Nulla semper tellus id nunc interdum feugiat. Sed nec",
    "estado": "Pendiente",
    "prestador_solicitante": "Molestie Institute",
    "prestador_actuante": "Sed Pharetra Foundation",
    "prestador_actuante_codigo": "8040",
    "fecha_desde": "2019-07-14",
    "fecha_hasta": "2020-05-26",
    "cantidad": 3,
    "frecuencia": "DIARIA",
    "det": "816",
    "descripcion": "metus sit amet ante. Vivamus non lorem vitae odio sagittis semper. Nam tempor diam dictum sapien.",
    "practicas": []
  },
  {
    "pedido": 50,
    "nro_asociado": "07331147/1",
    "apellido": "Carver",
    "nombre": "Sylvester",
    "plan": "T279",
    "localidad": "San Cristóbal de la Laguna",
    "cp": "49110",
    "direccion": "9434 Euismod Road",
    "provincia": "Canarias",
    "diagnostico": "nibh. Phasellus nulla. Integer vulputate, risus a ultricies adipiscing, enim",
    "estado": "Pendiente",
    "prestador_solicitante": "Consequat Enim Diam Incorporated",
    "prestador_actuante": "Molestie Institute",
    "prestador_actuante_codigo": "7562",
    "fecha_desde": "2019-02-19",
    "fecha_hasta": "2019-02-12",
    "cantidad": 2,
    "frecuencia": "DIARIA",
    "det": "524",
    "descripcion": "laoreet posuere, enim nisl elementum purus, accumsan",
    "practicas": []
  },
  {
    "pedido": 51,
    "nro_asociado": "11808255/1",
    "apellido": "Baker",
    "nombre": "Joel",
    "plan": "V005",
    "localidad": "La Reina",
    "cp": "004899",
    "direccion": "P.O. Box 881, 7706 Neque. Street",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "sed pede. Cum sociis natoque penatibus et magnis dis parturient",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Hymenaeos Mauris PC",
    "prestador_actuante": "Tincidunt Donec Vitae Inc.",
    "prestador_actuante_codigo": "0886",
    "fecha_desde": "2018-03-16",
    "fecha_hasta": "2018-12-30",
    "cantidad": 3,
    "frecuencia": "SEMANAL",
    "det": "151",
    "descripcion": "lorem, vehicula et, rutrum eu, ultrices sit amet, risus. Donec nibh enim, gravida sit amet, dapibus id, blandit at, nisi.",
    "practicas": []
  },
  {
    "pedido": 52,
    "nro_asociado": "23392615/1",
    "apellido": "Weeks",
    "nombre": "Jena",
    "plan": "X072",
    "localidad": "San Rafael",
    "cp": "10805",
    "direccion": "P.O. Box 797, 2672 Tellus Avenue",
    "provincia": "San José",
    "diagnostico": "non sapien molestie orci tincidunt adipiscing. Mauris molestie pharetra nibh.",
    "estado": "Pendiente",
    "prestador_solicitante": "Nulla At Sem PC",
    "prestador_actuante": "Cursus Et PC",
    "prestador_actuante_codigo": "2890",
    "fecha_desde": "2019-06-04",
    "fecha_hasta": "2019-01-13",
    "cantidad": 9,
    "frecuencia": "DIARIA",
    "det": "166",
    "descripcion": "lectus pede et risus. Quisque libero lacus, varius",
    "practicas": []
  },
  {
    "pedido": 53,
    "nro_asociado": "78912762/1",
    "apellido": "Beasley",
    "nombre": "Rebecca",
    "plan": "C694",
    "localidad": "Las Palmas",
    "cp": "67359",
    "direccion": "206-8802 Nisi Rd.",
    "provincia": "Canarias",
    "diagnostico": "sit amet ante. Vivamus non lorem vitae odio sagittis semper.",
    "estado": "Asignada",
    "prestador_solicitante": "Ut Pellentesque Company",
    "prestador_actuante": "Mauris Industries",
    "prestador_actuante_codigo": "0492",
    "fecha_desde": "2018-02-02",
    "fecha_hasta": "2020-05-26",
    "cantidad": 2,
    "frecuencia": "SEMANAL",
    "det": "762",
    "descripcion": "Mauris non dui nec urna suscipit nonummy. Fusce fermentum fermentum arcu. Vestibulum ante ipsum primis in faucibus orci luctus et",
    "practicas": []
  },
  {
    "pedido": 54,
    "nro_asociado": "04916174/1",
    "apellido": "Hooper",
    "nombre": "Jessica",
    "plan": "G379",
    "localidad": "Porto Alegre",
    "cp": "97236-426",
    "direccion": "Ap #259-3692 Rutrum St.",
    "provincia": "Rio Grande do Sul",
    "diagnostico": "adipiscing elit. Aliquam auctor, velit eget laoreet posuere, enim nisl",
    "estado": "Asignada",
    "prestador_solicitante": "Luctus Associates",
    "prestador_actuante": "Sed Eget Lacus Limited",
    "prestador_actuante_codigo": "1023",
    "fecha_desde": "2019-03-30",
    "fecha_hasta": "2019-12-08",
    "cantidad": 8,
    "frecuencia": "DIARIA",
    "det": "758",
    "descripcion": "mauris blandit mattis. Cras eget nisi dictum augue malesuada malesuada. Integer id magna",
    "practicas": []
  },
  {
    "pedido": 55,
    "nro_asociado": "34766515/1",
    "apellido": "Klein",
    "nombre": "Sonya",
    "plan": "R522",
    "localidad": "Marbella",
    "cp": "77125",
    "direccion": "P.O. Box 744, 6251 Amet Av.",
    "provincia": "Andalucía",
    "diagnostico": "sit amet, consectetuer adipiscing elit. Etiam laoreet, libero et tristique",
    "estado": "Asignada",
    "prestador_solicitante": "Facilisis Non Bibendum Incorporated",
    "prestador_actuante": "Tempor Industries",
    "prestador_actuante_codigo": "4488",
    "fecha_desde": "2019-01-15",
    "fecha_hasta": "2019-06-15",
    "cantidad": 3,
    "frecuencia": "SEMANAL",
    "det": "437",
    "descripcion": "vehicula aliquet libero. Integer in magna. Phasellus dolor elit, pellentesque a,",
    "practicas": []
  },
  {
    "pedido": 56,
    "nro_asociado": "67570722/1",
    "apellido": "Murphy",
    "nombre": "Candace",
    "plan": "P518",
    "localidad": "Torrejón de Ardoz",
    "cp": "67223",
    "direccion": "948-6884 Amet, Avenue",
    "provincia": "Madrid",
    "diagnostico": "orci quis lectus. Nullam suscipit, est ac facilisis facilisis, magna",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Nibh Lacinia Orci LLC",
    "prestador_actuante": "Proin Ultrices Duis Institute",
    "prestador_actuante_codigo": "3892",
    "fecha_desde": "2019-06-16",
    "fecha_hasta": "2019-10-10",
    "cantidad": 7,
    "frecuencia": "DIARIA",
    "det": "245",
    "descripcion": "Proin",
    "practicas": []
  },
  {
    "pedido": 57,
    "nro_asociado": "37459714/1",
    "apellido": "Davenport",
    "nombre": "Illana",
    "plan": "L567",
    "localidad": "Florianópolis",
    "cp": "89564-451",
    "direccion": "P.O. Box 902, 5525 Donec St.",
    "provincia": "Santa Catarina",
    "diagnostico": "semper rutrum. Fusce dolor quam, elementum at, egestas a, scelerisque",
    "estado": "Asignada",
    "prestador_solicitante": "Et Corp.",
    "prestador_actuante": "Amet LLP",
    "prestador_actuante_codigo": "0292",
    "fecha_desde": "2018-05-03",
    "fecha_hasta": "2019-05-08",
    "cantidad": 5,
    "frecuencia": "SEMANAL",
    "det": "335",
    "descripcion": "sapien imperdiet ornare. In faucibus. Morbi vehicula. Pellentesque tincidunt tempus risus. Donec egestas. Duis ac arcu. Nunc",
    "practicas": []
  },
  {
    "pedido": 58,
    "nro_asociado": "61161627/1",
    "apellido": "Glover",
    "nombre": "Hiroko",
    "plan": "H910",
    "localidad": "San Vicente",
    "cp": "11109",
    "direccion": "Ap #471-745 Et Ave",
    "provincia": "San José",
    "diagnostico": "lectus rutrum urna, nec luctus felis purus ac tellus. Suspendisse",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Aliquam Iaculis LLP",
    "prestador_actuante": "Risus Nunc Ac PC",
    "prestador_actuante_codigo": "9306",
    "fecha_desde": "2018-05-12",
    "fecha_hasta": "2020-01-15",
    "cantidad": 10,
    "frecuencia": "DIARIA",
    "det": "423",
    "descripcion": "in, dolor. Fusce",
    "practicas": []
  },
  {
    "pedido": 59,
    "nro_asociado": "72738710/1",
    "apellido": "Oliver",
    "nombre": "Marcia",
    "plan": "B922",
    "localidad": "Albacete",
    "cp": "71688",
    "direccion": "Ap #656-1875 Natoque Av.",
    "provincia": "Castilla - La Mancha",
    "diagnostico": "accumsan laoreet ipsum. Curabitur consequat, lectus sit amet luctus vulputate,",
    "estado": "Pendiente",
    "prestador_solicitante": "Mus Donec Dignissim LLP",
    "prestador_actuante": "Vel Est Ltd",
    "prestador_actuante_codigo": "7657",
    "fecha_desde": "2018-08-10",
    "fecha_hasta": "2019-02-28",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "984",
    "descripcion": "condimentum. Donec at arcu. Vestibulum ante",
    "practicas": []
  },
  {
    "pedido": 60,
    "nro_asociado": "79363558/1",
    "apellido": "Odom",
    "nombre": "Jarrod",
    "plan": "R627",
    "localidad": "Curanilahue",
    "cp": "608270",
    "direccion": "3654 Augue Rd.",
    "provincia": "Biobío",
    "diagnostico": "convallis dolor. Quisque tincidunt pede ac urna. Ut tincidunt vehicula",
    "estado": "Pendiente",
    "prestador_solicitante": "Neque Associates",
    "prestador_actuante": "Molestie Dapibus Foundation",
    "prestador_actuante_codigo": "3317",
    "fecha_desde": "2019-09-03",
    "fecha_hasta": "2019-01-15",
    "cantidad": 10,
    "frecuencia": "DIARIA",
    "det": "357",
    "descripcion": "nec ante blandit viverra. Donec tempus, lorem fringilla ornare placerat, orci lacus vestibulum lorem,",
    "practicas": []
  },
  {
    "pedido": 61,
    "nro_asociado": "93565462/1",
    "apellido": "Moon",
    "nombre": "Geoffrey",
    "plan": "P588",
    "localidad": "Macul",
    "cp": "907067",
    "direccion": "559-9761 Nisi. Avenue",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "cursus. Nunc mauris elit, dictum eu, eleifend nec, malesuada ut,",
    "estado": "Pendiente",
    "prestador_solicitante": "Phasellus Libero Mauris Limited",
    "prestador_actuante": "Ipsum Ltd",
    "prestador_actuante_codigo": "4734",
    "fecha_desde": "2018-09-11",
    "fecha_hasta": "2019-12-18",
    "cantidad": 6,
    "frecuencia": "DIARIA",
    "det": "459",
    "descripcion": "quis diam luctus lobortis. Class aptent taciti sociosqu ad litora torquent",
    "practicas": []
  },
  {
    "pedido": 62,
    "nro_asociado": "42877637/1",
    "apellido": "Jenkins",
    "nombre": "Stacy",
    "plan": "U092",
    "localidad": "Gasteiz",
    "cp": "38729",
    "direccion": "Ap #709-6535 Tellus Avenue",
    "provincia": "Euskadi",
    "diagnostico": "morbi tristique senectus et netus et malesuada fames ac turpis",
    "estado": "Asignada",
    "prestador_solicitante": "Vitae Corp.",
    "prestador_actuante": "Imperdiet Ullamcorper Consulting",
    "prestador_actuante_codigo": "2449",
    "fecha_desde": "2018-02-01",
    "fecha_hasta": "2019-10-21",
    "cantidad": 1,
    "frecuencia": "SEMANAL",
    "det": "998",
    "descripcion": "nec enim. Nunc ut erat.",
    "practicas": []
  },
  {
    "pedido": 63,
    "nro_asociado": "47833968/1",
    "apellido": "Carey",
    "nombre": "Hayden",
    "plan": "S038",
    "localidad": "Quillota",
    "cp": "633062",
    "direccion": "P.O. Box 231, 7994 In St.",
    "provincia": "Valparaíso",
    "diagnostico": "orci luctus et ultrices posuere cubilia Curae; Phasellus ornare. Fusce",
    "estado": "Pendiente",
    "prestador_solicitante": "Non LLC",
    "prestador_actuante": "Vitae Posuere Incorporated",
    "prestador_actuante_codigo": "2902",
    "fecha_desde": "2018-06-21",
    "fecha_hasta": "2018-12-25",
    "cantidad": 2,
    "frecuencia": "DIARIA",
    "det": "873",
    "descripcion": "dictum eu, placerat eget, venenatis",
    "practicas": []
  },
  {
    "pedido": 64,
    "nro_asociado": "63864217/1",
    "apellido": "Horn",
    "nombre": "Joel",
    "plan": "C785",
    "localidad": "Dalcahue",
    "cp": "715641",
    "direccion": "P.O. Box 395, 2044 Nunc Rd.",
    "provincia": "Los Lagos",
    "diagnostico": "facilisis non, bibendum sed, est. Nunc laoreet lectus quis massa.",
    "estado": "Asignada",
    "prestador_solicitante": "Ridiculus Mus Corporation",
    "prestador_actuante": "Pellentesque Habitant Institute",
    "prestador_actuante_codigo": "4640",
    "fecha_desde": "2018-05-21",
    "fecha_hasta": "2019-03-05",
    "cantidad": 3,
    "frecuencia": "DIARIA",
    "det": "573",
    "descripcion": "natoque penatibus et",
    "practicas": []
  },
  {
    "pedido": 65,
    "nro_asociado": "50947015/1",
    "apellido": "Chase",
    "nombre": "Jamal",
    "plan": "G121",
    "localidad": "Lugo",
    "cp": "12397",
    "direccion": "P.O. Box 164, 535 Non, Rd.",
    "provincia": "Galicia",
    "diagnostico": "ornare, lectus ante dictum mi, ac mattis velit justo nec",
    "estado": "Pendiente",
    "prestador_solicitante": "Morbi Non Sapien LLC",
    "prestador_actuante": "Sodales Limited",
    "prestador_actuante_codigo": "4753",
    "fecha_desde": "2019-05-11",
    "fecha_hasta": "2020-03-11",
    "cantidad": 4,
    "frecuencia": "DIARIA",
    "det": "323",
    "descripcion": "dis parturient montes, nascetur ridiculus mus. Donec dignissim magna a tortor. Nunc commodo auctor velit.",
    "practicas": []
  },
  {
    "pedido": 66,
    "nro_asociado": "74173111/1",
    "apellido": "Hurley",
    "nombre": "Rana",
    "plan": "K735",
    "localidad": "San Miguel",
    "cp": "11613",
    "direccion": "9629 In St.",
    "provincia": "San José",
    "diagnostico": "Etiam vestibulum massa rutrum magna. Cras convallis convallis dolor. Quisque",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Ac Turpis Egestas Limited",
    "prestador_actuante": "Egestas Rhoncus LLP",
    "prestador_actuante_codigo": "6647",
    "fecha_desde": "2018-12-04",
    "fecha_hasta": "2019-05-30",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "223",
    "descripcion": "Donec tincidunt. Donec vitae erat vel pede blandit congue.",
    "practicas": []
  },
  {
    "pedido": 67,
    "nro_asociado": "86507070/1",
    "apellido": "Roberts",
    "nombre": "Nash",
    "plan": "P384",
    "localidad": "Fuenlabrada",
    "cp": "10816",
    "direccion": "Ap #101-1103 Augue, Street",
    "provincia": "Madrid",
    "diagnostico": "vulputate, nisi sem semper erat, in consectetuer ipsum nunc id",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Aliquam Ornare Limited",
    "prestador_actuante": "Sed Incorporated",
    "prestador_actuante_codigo": "4834",
    "fecha_desde": "2018-12-10",
    "fecha_hasta": "2019-02-01",
    "cantidad": 1,
    "frecuencia": "DIARIA",
    "det": "626",
    "descripcion": "imperdiet ornare. In faucibus. Morbi vehicula. Pellentesque tincidunt",
    "practicas": []
  },
  {
    "pedido": 68,
    "nro_asociado": "90845567/1",
    "apellido": "Guthrie",
    "nombre": "Laith",
    "plan": "T815",
    "localidad": "Las Condes",
    "cp": "458138",
    "direccion": "P.O. Box 607, 5895 Ut Street",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "euismod est arcu ac orci. Ut semper pretium neque. Morbi",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Et Commodo Associates",
    "prestador_actuante": "Dictum Incorporated",
    "prestador_actuante_codigo": "2061",
    "fecha_desde": "2019-03-31",
    "fecha_hasta": "2020-04-07",
    "cantidad": 5,
    "frecuencia": "DIARIA",
    "det": "456",
    "descripcion": "id, libero. Donec consectetuer mauris id sapien.",
    "practicas": []
  },
  {
    "pedido": 69,
    "nro_asociado": "41192664/1",
    "apellido": "Mcintyre",
    "nombre": "Lane",
    "plan": "A911",
    "localidad": "Alajuela",
    "cp": "20707",
    "direccion": "1609 Mattis. Avenue",
    "provincia": "Alajuela",
    "diagnostico": "Nam interdum enim non nisi. Aenean eget metus. In nec",
    "estado": "Pendiente",
    "prestador_solicitante": "Vel Nisl Quisque Ltd",
    "prestador_actuante": "Condimentum Associates",
    "prestador_actuante_codigo": "3515",
    "fecha_desde": "2018-06-18",
    "fecha_hasta": "2020-06-22",
    "cantidad": 5,
    "frecuencia": "DIARIA",
    "det": "504",
    "descripcion": "ullamcorper, nisl",
    "practicas": []
  },
  {
    "pedido": 70,
    "nro_asociado": "98032865/1",
    "apellido": "Gutierrez",
    "nombre": "Reed",
    "plan": "C319",
    "localidad": "San Rafael",
    "cp": "30719",
    "direccion": "947-529 Facilisis. Rd.",
    "provincia": "Cartago",
    "diagnostico": "mauris a nunc. In at pede. Cras vulputate velit eu",
    "estado": "Pendiente",
    "prestador_solicitante": "Ultricies Ligula Nullam Ltd",
    "prestador_actuante": "Vitae Dolor Donec Industries",
    "prestador_actuante_codigo": "6835",
    "fecha_desde": "2019-03-15",
    "fecha_hasta": "2020-05-07",
    "cantidad": 1,
    "frecuencia": "SEMANAL",
    "det": "858",
    "descripcion": "mollis. Duis sit amet",
    "practicas": []
  },
  {
    "pedido": 71,
    "nro_asociado": "31821970/1",
    "apellido": "Kerr",
    "nombre": "Joshua",
    "plan": "G536",
    "localidad": "Ilhéus",
    "cp": "47726-075",
    "direccion": "4410 Ornare, Av.",
    "provincia": "Bahia",
    "diagnostico": "eget varius ultrices, mauris ipsum porta elit, a feugiat tellus",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Quisque Libero Consulting",
    "prestador_actuante": "Cras Lorem Company",
    "prestador_actuante_codigo": "5195",
    "fecha_desde": "2019-05-13",
    "fecha_hasta": "2020-04-10",
    "cantidad": 9,
    "frecuencia": "DIARIA",
    "det": "674",
    "descripcion": "enim. Suspendisse aliquet, sem ut cursus",
    "practicas": []
  },
  {
    "pedido": 72,
    "nro_asociado": "44166877/1",
    "apellido": "Lane",
    "nombre": "Graham",
    "plan": "H449",
    "localidad": "San José de Alajuela",
    "cp": "20309",
    "direccion": "P.O. Box 435, 8956 Aliquam Rd.",
    "provincia": "Alajuela",
    "diagnostico": "Pellentesque ultricies dignissim lacus. Aliquam rutrum lorem ac risus. Morbi",
    "estado": "Pendiente",
    "prestador_solicitante": "Vestibulum Inc.",
    "prestador_actuante": "Luctus Et Ultrices Associates",
    "prestador_actuante_codigo": "5759",
    "fecha_desde": "2019-02-08",
    "fecha_hasta": "2019-04-29",
    "cantidad": 7,
    "frecuencia": "DIARIA",
    "det": "200",
    "descripcion": "elit erat vitae risus. Duis a mi fringilla mi lacinia mattis. Integer eu lacus. Quisque",
    "practicas": []
  },
  {
    "pedido": 73,
    "nro_asociado": "43084187/1",
    "apellido": "Long",
    "nombre": "Yasir",
    "plan": "E358",
    "localidad": "La Florida",
    "cp": "227702",
    "direccion": "P.O. Box 207, 2624 Tincidunt Av.",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "sed tortor. Integer aliquam adipiscing lacus. Ut nec urna et",
    "estado": "Pendiente",
    "prestador_solicitante": "Mauris Blandit PC",
    "prestador_actuante": "Proin PC",
    "prestador_actuante_codigo": "0144",
    "fecha_desde": "2018-01-09",
    "fecha_hasta": "2019-06-14",
    "cantidad": 1,
    "frecuencia": "DIARIA",
    "det": "092",
    "descripcion": "ipsum leo elementum sem, vitae aliquam eros turpis non enim. Mauris quis turpis vitae purus gravida sagittis. Duis gravida. Praesent",
    "practicas": []
  },
  {
    "pedido": 74,
    "nro_asociado": "87701259/1",
    "apellido": "Mendez",
    "nombre": "Calista",
    "plan": "M235",
    "localidad": "Coihueco",
    "cp": "851253",
    "direccion": "P.O. Box 836, 8236 Risus Ave",
    "provincia": "Biobío",
    "diagnostico": "urna suscipit nonummy. Fusce fermentum fermentum arcu. Vestibulum ante ipsum",
    "estado": "Asignada",
    "prestador_solicitante": "Quam Curabitur LLC",
    "prestador_actuante": "Velit Aliquam LLC",
    "prestador_actuante_codigo": "5688",
    "fecha_desde": "2018-05-20",
    "fecha_hasta": "2019-06-03",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "043",
    "descripcion": "dapibus rutrum, justo. Praesent luctus. Curabitur egestas nunc",
    "practicas": []
  },
  {
    "pedido": 75,
    "nro_asociado": "18527113/1",
    "apellido": "Herrera",
    "nombre": "Buckminster",
    "plan": "H133",
    "localidad": "Guadalajara",
    "cp": "06718",
    "direccion": "P.O. Box 404, 9824 Torquent Street",
    "provincia": "Castilla - La Mancha",
    "diagnostico": "vel arcu. Curabitur ut odio vel est tempor bibendum. Donec",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "A Scelerisque Incorporated",
    "prestador_actuante": "Faucibus Lectus LLC",
    "prestador_actuante_codigo": "4323",
    "fecha_desde": "2018-04-19",
    "fecha_hasta": "2020-06-22",
    "cantidad": 9,
    "frecuencia": "SEMANAL",
    "det": "701",
    "descripcion": "a, arcu. Sed et libero. Proin mi.",
    "practicas": []
  },
  {
    "pedido": 76,
    "nro_asociado": "57381411/1",
    "apellido": "Bishop",
    "nombre": "Fallon",
    "plan": "P685",
    "localidad": "Petrópolis",
    "cp": "27068-250",
    "direccion": "Ap #446-7891 Tincidunt St.",
    "provincia": "Rio de Janeiro",
    "diagnostico": "vitae odio sagittis semper. Nam tempor diam dictum sapien. Aenean",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Ultrices A Corp.",
    "prestador_actuante": "Urna Nullam Lobortis Associates",
    "prestador_actuante_codigo": "8173",
    "fecha_desde": "2018-06-14",
    "fecha_hasta": "2018-09-13",
    "cantidad": 2,
    "frecuencia": "DIARIA",
    "det": "206",
    "descripcion": "metus. In lorem. Donec elementum, lorem ut aliquam iaculis, lacus pede sagittis augue, eu",
    "practicas": []
  },
  {
    "pedido": 77,
    "nro_asociado": "81358287/1",
    "apellido": "Gomez",
    "nombre": "Dai",
    "plan": "Y712",
    "localidad": "San Juan (San Juan de Tibás)",
    "cp": "12201",
    "direccion": "636-5979 Ac Road",
    "provincia": "San José",
    "diagnostico": "nunc sed libero. Proin sed turpis nec mauris blandit mattis.",
    "estado": "Asignada",
    "prestador_solicitante": "Sed Corp.",
    "prestador_actuante": "Nisi Cum Sociis Ltd",
    "prestador_actuante_codigo": "6552",
    "fecha_desde": "2018-05-05",
    "fecha_hasta": "2019-01-18",
    "cantidad": 1,
    "frecuencia": "DIARIA",
    "det": "831",
    "descripcion": "interdum enim non nisi. Aenean eget metus. In nec orci. Donec nibh. Quisque",
    "practicas": []
  },
  {
    "pedido": 78,
    "nro_asociado": "85780236/1",
    "apellido": "Simmons",
    "nombre": "Rahim",
    "plan": "Y048",
    "localidad": "Lautaro",
    "cp": "574330",
    "direccion": "2279 Mattis Rd.",
    "provincia": "Araucanía",
    "diagnostico": "nisi. Cum sociis natoque penatibus et magnis dis parturient montes,",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Vitae Diam Proin Company",
    "prestador_actuante": "Ipsum Ltd",
    "prestador_actuante_codigo": "0929",
    "fecha_desde": "2019-03-13",
    "fecha_hasta": "2018-08-22",
    "cantidad": 3,
    "frecuencia": "DIARIA",
    "det": "038",
    "descripcion": "lectus rutrum urna, nec luctus felis purus ac tellus. Suspendisse sed dolor. Fusce mi lorem, vehicula et,",
    "practicas": []
  },
  {
    "pedido": 79,
    "nro_asociado": "10778688/1",
    "apellido": "Whitney",
    "nombre": "Leo",
    "plan": "W478",
    "localidad": "Mercedes",
    "cp": "41506",
    "direccion": "Ap #692-6258 Velit. Av.",
    "provincia": "Heredia",
    "diagnostico": "egestas nunc sed libero. Proin sed turpis nec mauris blandit",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Quisque LLC",
    "prestador_actuante": "Mus Aenean Eget Corp.",
    "prestador_actuante_codigo": "1355",
    "fecha_desde": "2019-03-22",
    "fecha_hasta": "2019-11-27",
    "cantidad": 8,
    "frecuencia": "DIARIA",
    "det": "556",
    "descripcion": "egestas. Sed pharetra, felis eget varius ultrices, mauris ipsum porta elit,",
    "practicas": []
  },
  {
    "pedido": 80,
    "nro_asociado": "84333227/1",
    "apellido": "Melendez",
    "nombre": "Reese",
    "plan": "Z717",
    "localidad": "Cinco Esquinas",
    "cp": "10209",
    "direccion": "5563 Condimentum Av.",
    "provincia": "San José",
    "diagnostico": "arcu et pede. Nunc sed orci lobortis augue scelerisque mollis.",
    "estado": "Pendiente",
    "prestador_solicitante": "Nulla Eget Associates",
    "prestador_actuante": "Lacinia Orci Inc.",
    "prestador_actuante_codigo": "4601",
    "fecha_desde": "2018-01-22",
    "fecha_hasta": "2018-12-14",
    "cantidad": 8,
    "frecuencia": "SEMANAL",
    "det": "109",
    "descripcion": "sit amet ante. Vivamus non lorem vitae odio sagittis semper. Nam tempor diam",
    "practicas": []
  },
  {
    "pedido": 81,
    "nro_asociado": "12069155/1",
    "apellido": "Mason",
    "nombre": "Reece",
    "plan": "G725",
    "localidad": "Santa Bárbara",
    "cp": "082981",
    "direccion": "P.O. Box 227, 9412 Integer Rd.",
    "provincia": "Biobío",
    "diagnostico": "orci quis lectus. Nullam suscipit, est ac facilisis facilisis, magna",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Mauris Integer Inc.",
    "prestador_actuante": "Sit Amet Limited",
    "prestador_actuante_codigo": "0347",
    "fecha_desde": "2019-05-28",
    "fecha_hasta": "2019-04-30",
    "cantidad": 9,
    "frecuencia": "DIARIA",
    "det": "253",
    "descripcion": "risus. Donec egestas.",
    "practicas": []
  },
  {
    "pedido": 82,
    "nro_asociado": "80356103/1",
    "apellido": "Walker",
    "nombre": "Liberty",
    "plan": "N188",
    "localidad": "Madrid",
    "cp": "37365",
    "direccion": "611-4151 Malesuada Ave",
    "provincia": "Madrid",
    "diagnostico": "auctor velit. Aliquam nisl. Nulla eu neque pellentesque massa lobortis",
    "estado": "Pendiente",
    "prestador_solicitante": "Accumsan Ltd",
    "prestador_actuante": "Vel Pede Limited",
    "prestador_actuante_codigo": "2984",
    "fecha_desde": "2018-12-06",
    "fecha_hasta": "2018-09-15",
    "cantidad": 5,
    "frecuencia": "DIARIA",
    "det": "333",
    "descripcion": "Nunc quis arcu vel quam dignissim pharetra. Nam ac nulla. In tincidunt congue turpis. In condimentum.",
    "practicas": []
  },
  {
    "pedido": 83,
    "nro_asociado": "66341104/1",
    "apellido": "Richmond",
    "nombre": "Willow",
    "plan": "I103",
    "localidad": "San Felipe",
    "cp": "12206",
    "direccion": "P.O. Box 137, 8539 Posuere Avenue",
    "provincia": "San José",
    "diagnostico": "litora torquent per conubia nostra, per inceptos hymenaeos. Mauris ut",
    "estado": "Pendiente",
    "prestador_solicitante": "Tellus Suspendisse Corporation",
    "prestador_actuante": "Neque In PC",
    "prestador_actuante_codigo": "6380",
    "fecha_desde": "2018-07-18",
    "fecha_hasta": "2019-07-22",
    "cantidad": 5,
    "frecuencia": "DIARIA",
    "det": "916",
    "descripcion": "aliquet. Phasellus fermentum convallis ligula. Donec",
    "practicas": []
  },
  {
    "pedido": 84,
    "nro_asociado": "45447176/1",
    "apellido": "Crane",
    "nombre": "Jada",
    "plan": "R109",
    "localidad": "San Cristóbal de la Laguna",
    "cp": "93935",
    "direccion": "Ap #480-805 Nibh St.",
    "provincia": "Canarias",
    "diagnostico": "a, aliquet vel, vulputate eu, odio. Phasellus at augue id",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Augue Sed Molestie Industries",
    "prestador_actuante": "Cras Foundation",
    "prestador_actuante_codigo": "3279",
    "fecha_desde": "2018-06-30",
    "fecha_hasta": "2018-10-22",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "922",
    "descripcion": "nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique neque venenatis lacus. Etiam bibendum fermentum",
    "practicas": []
  },
  {
    "pedido": 85,
    "nro_asociado": "04032485/1",
    "apellido": "Booker",
    "nombre": "Charde",
    "plan": "L935",
    "localidad": "Bilbo",
    "cp": "66436",
    "direccion": "Ap #150-1572 Aliquam Av.",
    "provincia": "Euskadi",
    "diagnostico": "Aliquam adipiscing lobortis risus. In mi pede, nonummy ut, molestie",
    "estado": "Asignada",
    "prestador_solicitante": "Nam Consequat Inc.",
    "prestador_actuante": "Nulla Donec Industries",
    "prestador_actuante_codigo": "0139",
    "fecha_desde": "2019-01-29",
    "fecha_hasta": "2020-07-15",
    "cantidad": 7,
    "frecuencia": "DIARIA",
    "det": "430",
    "descripcion": "Ut",
    "practicas": []
  },
  {
    "pedido": 86,
    "nro_asociado": "81298011/1",
    "apellido": "Collier",
    "nombre": "Harlan",
    "plan": "C658",
    "localidad": "Mauá",
    "cp": "11148-598",
    "direccion": "258-2482 Dis Rd.",
    "provincia": "São Paulo",
    "diagnostico": "Vivamus non lorem vitae odio sagittis semper. Nam tempor diam",
    "estado": "Pendiente",
    "prestador_solicitante": "Dis Parturient Montes Inc.",
    "prestador_actuante": "Est Nunc Laoreet Ltd",
    "prestador_actuante_codigo": "8646",
    "fecha_desde": "2018-04-10",
    "fecha_hasta": "2020-02-13",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "808",
    "descripcion": "pharetra nibh. Aliquam ornare, libero at auctor ullamcorper, nisl arcu iaculis enim, sit amet",
    "practicas": []
  },
  {
    "pedido": 87,
    "nro_asociado": "96495201/1",
    "apellido": "Schroeder",
    "nombre": "Mara",
    "plan": "Y705",
    "localidad": "Peñalolén",
    "cp": "246061",
    "direccion": "P.O. Box 748, 6379 Libero St.",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "nunc ac mattis ornare, lectus ante dictum mi, ac mattis",
    "estado": "Asignada",
    "prestador_solicitante": "Nulla LLC",
    "prestador_actuante": "Consequat Purus Corporation",
    "prestador_actuante_codigo": "2591",
    "fecha_desde": "2018-07-09",
    "fecha_hasta": "2020-06-03",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "359",
    "descripcion": "ridiculus mus. Proin vel nisl. Quisque fringilla euismod enim. Etiam gravida molestie arcu.",
    "practicas": []
  },
  {
    "pedido": 88,
    "nro_asociado": "75625435/1",
    "apellido": "Savage",
    "nombre": "Kathleen",
    "plan": "U383",
    "localidad": "Ribeirão Preto",
    "cp": "13254-555",
    "direccion": "418-8735 Nec St.",
    "provincia": "São Paulo",
    "diagnostico": "dolor. Fusce feugiat. Lorem ipsum dolor sit amet, consectetuer adipiscing",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Eu Inc.",
    "prestador_actuante": "Vel Incorporated",
    "prestador_actuante_codigo": "8279",
    "fecha_desde": "2019-08-16",
    "fecha_hasta": "2018-11-04",
    "cantidad": 5,
    "frecuencia": "SEMANAL",
    "det": "877",
    "descripcion": "sit amet, consectetuer adipiscing elit. Aliquam auctor, velit eget laoreet posuere, enim nisl elementum purus, accumsan interdum libero dui nec",
    "practicas": []
  },
  {
    "pedido": 89,
    "nro_asociado": "17309489/1",
    "apellido": "Cross",
    "nombre": "Francis",
    "plan": "Z632",
    "localidad": "Quesada",
    "cp": "20808",
    "direccion": "P.O. Box 799, 5031 Et, Avenue",
    "provincia": "Alajuela",
    "diagnostico": "faucibus lectus, a sollicitudin orci sem eget massa. Suspendisse eleifend.",
    "estado": "Asignada",
    "prestador_solicitante": "Ut Tincidunt LLP",
    "prestador_actuante": "Mauris Inc.",
    "prestador_actuante_codigo": "7601",
    "fecha_desde": "2019-07-18",
    "fecha_hasta": "2019-09-05",
    "cantidad": 8,
    "frecuencia": "DIARIA",
    "det": "172",
    "descripcion": "velit. Aliquam nisl. Nulla eu neque pellentesque massa lobortis ultrices. Vivamus rhoncus. Donec",
    "practicas": []
  },
  {
    "pedido": 90,
    "nro_asociado": "18573162/1",
    "apellido": "Vincent",
    "nombre": "Kato",
    "plan": "T350",
    "localidad": "Zapallar",
    "cp": "054163",
    "direccion": "Ap #163-520 Id, St.",
    "provincia": "Valparaíso",
    "diagnostico": "tortor at risus. Nunc ac sem ut dolor dapibus gravida.",
    "estado": "Pendiente",
    "prestador_solicitante": "Dolor Industries",
    "prestador_actuante": "Fringilla Euismod Institute",
    "prestador_actuante_codigo": "5141",
    "fecha_desde": "2019-09-11",
    "fecha_hasta": "2019-02-27",
    "cantidad": 6,
    "frecuencia": "DIARIA",
    "det": "711",
    "descripcion": "nec luctus felis purus ac tellus. Suspendisse sed dolor. Fusce mi lorem, vehicula",
    "practicas": []
  },
  {
    "pedido": 91,
    "nro_asociado": "32107261/1",
    "apellido": "Stout",
    "nombre": "Debra",
    "plan": "D032",
    "localidad": "Contagem",
    "cp": "31994212",
    "direccion": "4540 Ut, St.",
    "provincia": "Minas Gerais",
    "diagnostico": "amet ante. Vivamus non lorem vitae odio sagittis semper. Nam",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Odio Vel Est LLP",
    "prestador_actuante": "Vivamus Sit Incorporated",
    "prestador_actuante_codigo": "9115",
    "fecha_desde": "2019-08-17",
    "fecha_hasta": "2019-09-24",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "521",
    "descripcion": "malesuada fringilla est. Mauris eu turpis. Nulla aliquet. Proin velit. Sed malesuada augue ut lacus. Nulla tincidunt, neque",
    "practicas": []
  },
  {
    "pedido": 92,
    "nro_asociado": "25614355/1",
    "apellido": "Hunt",
    "nombre": "Edward",
    "plan": "N160",
    "localidad": "Pedro Aguirre Cerda",
    "cp": "863797",
    "direccion": "6161 Tellus Road",
    "provincia": "Metropolitana de Santiago",
    "diagnostico": "eget lacus. Mauris non dui nec urna suscipit nonummy. Fusce",
    "estado": "Asignada",
    "prestador_solicitante": "Ut PC",
    "prestador_actuante": "Class Aptent Corporation",
    "prestador_actuante_codigo": "1328",
    "fecha_desde": "2019-01-26",
    "fecha_hasta": "2019-08-27",
    "cantidad": 1,
    "frecuencia": "DIARIA",
    "det": "492",
    "descripcion": "quis urna. Nunc quis arcu vel quam dignissim pharetra. Nam ac",
    "practicas": []
  },
  {
    "pedido": 93,
    "nro_asociado": "42322376/1",
    "apellido": "Sweeney",
    "nombre": "Donna",
    "plan": "I675",
    "localidad": "Duque de Caxias",
    "cp": "23535-844",
    "direccion": "7463 Eleifend. Street",
    "provincia": "Rio de Janeiro",
    "diagnostico": "ipsum dolor sit amet, consectetuer adipiscing elit. Etiam laoreet, libero",
    "estado": "Asignada",
    "prestador_solicitante": "Consectetuer Cursus Et Corporation",
    "prestador_actuante": "Pede Limited",
    "prestador_actuante_codigo": "8924",
    "fecha_desde": "2018-02-24",
    "fecha_hasta": "2020-02-16",
    "cantidad": 8,
    "frecuencia": "SEMANAL",
    "det": "338",
    "descripcion": "nisl arcu iaculis enim, sit amet ornare lectus justo eu arcu. Morbi sit amet massa.",
    "practicas": []
  },
  {
    "pedido": 94,
    "nro_asociado": "61673364/1",
    "apellido": "Kirkland",
    "nombre": "Alfonso",
    "plan": "I026",
    "localidad": "Tejar",
    "cp": "30115",
    "direccion": "708-3762 In Rd.",
    "provincia": "Cartago",
    "diagnostico": "vitae velit egestas lacinia. Sed congue, elit sed consequat auctor,",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Cursus Luctus Ipsum LLC",
    "prestador_actuante": "Sem Consequat LLP",
    "prestador_actuante_codigo": "3555",
    "fecha_desde": "2018-12-01",
    "fecha_hasta": "2019-08-04",
    "cantidad": 6,
    "frecuencia": "DIARIA",
    "det": "854",
    "descripcion": "mollis. Duis sit amet diam eu dolor egestas rhoncus. Proin nisl sem, consequat nec, mollis",
    "practicas": [
      {
    		"det": "292",
    		"descripcion": "sapien. Nunc pulvinar arcu et pede. Nunc",
    		"fecha_desde": "2020-04-17",
    		"fecha_hasta": "2019-03-24",
    		"cantidad": 10,
    		"frecuencia": "DIARIA"
    	},
    	{
    		"det": "730",
    		"descripcion": "neque vitae semper egestas, urna justo faucibus lectus, a sollicitudin orci sem eget",
    		"fecha_desde": "2019-05-23",
    		"fecha_hasta": "2019-01-31",
    		"cantidad": 6,
    		"frecuencia": "DIARIA"
    	}
    ]
  },
  {
    "pedido": 95,
    "nro_asociado": "99947863/1",
    "apellido": "Rivers",
    "nombre": "Palmer",
    "plan": "U514",
    "localidad": "Dos Hermanas",
    "cp": "88729",
    "direccion": "1019 Ipsum. Rd.",
    "provincia": "Andalucía",
    "diagnostico": "Nulla aliquet. Proin velit. Sed malesuada augue ut lacus. Nulla",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Netus Et Malesuada Associates",
    "prestador_actuante": "Ante Blandit Viverra Foundation",
    "prestador_actuante_codigo": "5504",
    "fecha_desde": "2019-09-16",
    "fecha_hasta": "2020-05-17",
    "cantidad": 10,
    "frecuencia": "SEMANAL",
    "det": "966",
    "descripcion": "Morbi quis urna. Nunc quis arcu vel quam dignissim pharetra. Nam",
    "practicas": []
  },
  {
    "pedido": 96,
    "nro_asociado": "74108023/1",
    "apellido": "Barton",
    "nombre": "David",
    "plan": "X893",
    "localidad": "Los Sauces",
    "cp": "031992",
    "direccion": "286-1796 Curabitur Rd.",
    "provincia": "Araucanía",
    "diagnostico": "commodo tincidunt nibh. Phasellus nulla. Integer vulputate, risus a ultricies",
    "estado": "Pendiente",
    "prestador_solicitante": "Consectetuer Mauris Id LLC",
    "prestador_actuante": "Quam Corporation",
    "prestador_actuante_codigo": "9682",
    "fecha_desde": "2019-07-24",
    "fecha_hasta": "2019-10-04",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "579",
    "descripcion": "nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique neque venenatis lacus. Etiam bibendum fermentum metus. Aenean sed",
    "practicas": []
  },
  {
    "pedido": 97,
    "nro_asociado": "56543139/1",
    "apellido": "Mcfadden",
    "nombre": "Gabriel",
    "plan": "Y113",
    "localidad": "Donosti",
    "cp": "33880",
    "direccion": "P.O. Box 486, 565 Libero St.",
    "provincia": "Euskadi",
    "diagnostico": "Cras interdum. Nunc sollicitudin commodo ipsum. Suspendisse non leo. Vivamus",
    "estado": "Pendiente",
    "prestador_solicitante": "Viverra Donec Limited",
    "prestador_actuante": "Ultrices Posuere LLC",
    "prestador_actuante_codigo": "9503",
    "fecha_desde": "2019-01-17",
    "fecha_hasta": "2019-06-24",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "420",
    "descripcion": "erat. Etiam vestibulum massa rutrum magna.",
    "practicas": []
  },
  {
    "pedido": 98,
    "nro_asociado": "34443714/1",
    "apellido": "Farmer",
    "nombre": "Evelyn",
    "plan": "Z353",
    "localidad": "Los Sauces",
    "cp": "140911",
    "direccion": "Ap #715-4128 Quam St.",
    "provincia": "Araucanía",
    "diagnostico": "Quisque porttitor eros nec tellus. Nunc lectus pede, ultrices a,",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Nec Mollis PC",
    "prestador_actuante": "Phasellus Vitae Corporation",
    "prestador_actuante_codigo": "7472",
    "fecha_desde": "2019-01-12",
    "fecha_hasta": "2020-07-20",
    "cantidad": 3,
    "frecuencia": "SEMANAL",
    "det": "753",
    "descripcion": "Phasellus vitae mauris sit amet lorem semper auctor. Mauris vel",
    "practicas": []
  },
  {
    "pedido": 99,
    "nro_asociado": "55907311/1",
    "apellido": "Carey",
    "nombre": "Zephr",
    "plan": "P353",
    "localidad": "Recife",
    "cp": "54281-418",
    "direccion": "Ap #449-7002 Cras Av.",
    "provincia": "Pernambuco",
    "diagnostico": "vel, convallis in, cursus et, eros. Proin ultrices. Duis volutpat",
    "estado": "Parcialmente Asignada",
    "prestador_solicitante": "Magnis Dis Industries",
    "prestador_actuante": "Consectetuer Institute",
    "prestador_actuante_codigo": "1458",
    "fecha_desde": "2019-04-14",
    "fecha_hasta": "2020-04-22",
    "cantidad": 7,
    "frecuencia": "SEMANAL",
    "det": "129",
    "descripcion": "elit pede, malesuada vel, venenatis vel, faucibus id, libero. Donec consectetuer mauris id sapien. Cras dolor dolor, tempus non, lacinia",
    "practicas": [
      {
    		"det": "896",
    		"descripcion": "sed sem egestas blandit. Nam nulla magna, malesuada vel, convallis in, cursus et,",
    		"fecha_desde": "2019-09-13",
    		"fecha_hasta": "2019-04-17",
    		"cantidad": 7,
    		"frecuencia": "DIARIA"
    	},
    	{
    		"det": "226",
    		"descripcion": "enim non nisi. Aenean eget metus. In nec orci. Donec nibh.",
    		"fecha_desde": "2018-11-07",
    		"fecha_hasta": "2018-09-09",
    		"cantidad": 5,
    		"frecuencia": "DIARIA"
    	},
    	{
    		"det": "760",
    		"descripcion": "eros turpis non enim. Mauris quis",
    		"fecha_desde": "2020-03-08",
    		"fecha_hasta": "2018-12-03",
    		"cantidad": 5,
    		"frecuencia": "DIARIA"
    	}
    ]
  },
  {
    "pedido": 100,
    "nro_asociado": "96642386/1",
    "apellido": "Whitehead",
    "nombre": "Wyatt",
    "plan": "I112",
    "localidad": "Palencia",
    "cp": "74987",
    "direccion": "P.O. Box 997, 4994 In Street",
    "provincia": "Castilla y León",
    "diagnostico": "iaculis aliquet diam. Sed diam lorem, auctor quis, tristique ac,",
    "estado": "Asignada",
    "prestador_solicitante": "Fringilla Cursus Purus Institute",
    "prestador_actuante": "Faucibus Ltd",
    "prestador_actuante_codigo": "2649",
    "fecha_desde": "2018-04-24",
    "fecha_hasta": "2020-06-30",
    "cantidad": 3,
    "frecuencia": "SEMANAL",
    "det": "131",
    "descripcion": "dolor, tempus non, lacinia at, iaculis quis, pede. Praesent eu dui. Cum sociis natoque penatibus et magnis dis parturient",
    "practicas": [
      {
    		"det": "512",
    		"descripcion": "Duis ac arcu. Nunc mauris. Morbi non sapien molestie orci tincidunt adipiscing. Mauris molestie pharetra nibh. Aliquam",
    		"fecha_desde": "2020-06-14",
    		"fecha_hasta": "2020-05-28",
    		"cantidad": 6,
    		"frecuencia": "DIARIA"
    	},
    	{
    		"det": "008",
    		"descripcion": "Nullam velit dui, semper et, lacinia vitae, sodales at, velit. Pellentesque ultricies dignissim lacus. Aliquam rutrum lorem ac",
    		"fecha_desde": "2018-09-30",
    		"fecha_hasta": "2018-09-16",
    		"cantidad": 7,
    		"frecuencia": "DIARIA"
    	}
    ]
  }
]
}
